'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuccessAlert = SuccessAlert;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function SuccessAlert(_ref) {
  var children = _ref.children;
  return _react2['default'].createElement('div', {
    className: 'feed-back-container feed-back-container--success'
  }, _react2['default'].createElement('h4', null, children));
}

SuccessAlert.propTypes = {
  children: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]).isRequired
};